import { render } from "./paper3.vue?vue&type=template&id=6306e7bf&scoped=true"
import script from "./paper3.vue?vue&type=script&lang=js"
export * from "./paper3.vue?vue&type=script&lang=js"

import "./paper3.vue?vue&type=style&index=0&id=6306e7bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6306e7bf"]])

export default __exports__